import {
    DailyTransactionTypeEnum,
    LookupItemModel,
    LookupTypeEnum,
    SearchDailyTransactionTypeEnum, SearchTransactionRequestModel
} from "../../../../../models";
import {useEffect, useState} from "react";
import {getLookupByType} from "../../../../../serviceBroker/lookupApiServiceBroker";
import {getLabelName} from "../../../../../utils";

export const useTransactionComponentList = (
    formId: number,
    transactionType: DailyTransactionTypeEnum
)=>{
    //#region variables
    const searchTypeList: LookupItemModel[] = [
        {
            name: getLabelName("ItemName"),
            nameAr: getLabelName("ItemName"),
            value: SearchDailyTransactionTypeEnum.itemName.toString(),
        },
        {
            name: getLabelName("ItemCode"),
            nameAr: getLabelName("ItemCode"),
            value: SearchDailyTransactionTypeEnum.code.toString(),
        },
        {
            name: getLabelName("barCode"),
            nameAr: getLabelName("barCode"),
            value: SearchDailyTransactionTypeEnum.barCode.toString(),
        },
        {
            name: getLabelName("Code"),
            nameAr: getLabelName("Code"),
            value: SearchDailyTransactionTypeEnum.transactionCode.toString(),
        },
    ];
    //#endregion
    //#region state
    const [beneficiaryList, setBeneficiaryList] = useState<LookupItemModel[]>([]);
    //const [cityList, setCityList] = useState<LookupItemModel[]>([]);
    const [isSalesComponent, setIsSalesComponent] = useState<boolean>(false);
    //#endregion
    //#region functions
    const isTransactionApplicableForPayment = () => {
        const transactionTypes = [DailyTransactionTypeEnum.SalesInvoice];
        return transactionTypes.includes(transactionType);
    };
    const isTransactionApplicableForRefund = () => {
        const transactionTypes = [
            DailyTransactionTypeEnum.PurchasesInvoice,
            DailyTransactionTypeEnum.SalesInvoice,
            DailyTransactionTypeEnum.POSSales,
            DailyTransactionTypeEnum.POSRestaurant,
        ];
        return transactionTypes.includes(transactionType);
    };
    const isTransactionApplicableForIssueSalesRequest = () => {
        const transactionTypes = [
            DailyTransactionTypeEnum.Order,
            DailyTransactionTypeEnum.ShowPrice,
            DailyTransactionTypeEnum.CarRegistration,
        ];
        return transactionTypes.includes(transactionType);
    };
    //#endregion
    //#region useEffect
    useEffect(() => {
        const transactionTypesForSales = [
            DailyTransactionTypeEnum.SalesInvoice,
            DailyTransactionTypeEnum.SalesRefund,
            DailyTransactionTypeEnum.ShowPrice,
            DailyTransactionTypeEnum.Order,
            DailyTransactionTypeEnum.POSSales,
            DailyTransactionTypeEnum.POSSalesRefund,
            DailyTransactionTypeEnum.POSRestaurant,
            DailyTransactionTypeEnum.Reserve_Restaurant_Bill,
            DailyTransactionTypeEnum.ReturnPOSRestaurant,
        ];

        setIsSalesComponent(
            transactionTypesForSales.includes(transactionType)
        );
    }, [transactionType]);
    // Fetch lookups when formId or isSalesComponent changes
    useEffect(() => {
        const fetchLookups = async () => {
            try {
                const [beneficiaryLookup] = await Promise.all([
                    getLookupByType(
                        isSalesComponent ? LookupTypeEnum.Customers : LookupTypeEnum.Supplier,
                        true,
                        false
                    ),
                   // getLookupByType(LookupTypeEnum.Cities, true, false),
                ]);

                setBeneficiaryList(beneficiaryLookup || []);
              //  setCityList(cityLookup || []);
            } catch (error) {
                console.error("Error fetching lookups", error);
            }
        };

        if (formId) {
            fetchLookups().then(() => {});
        }
    }, [formId, isSalesComponent]);
    //#endregion
    return {
        isSalesComponent,
        beneficiaryList,
        searchTypeList,
      //  cityList,
    }
}